export const checkIfStringAndDash = (value: string) => {
  return /^-?[\d-]*$/.test(value) || value === "";
};
